<template>
  <ElDialog
      v-model="isShow"
      :title="$t('common.email.addCustomer')"
      :footer="null"
      centered
      top="4em"
      :width="'95%'"
      style="max-width: 1400px;"
      destroyOnClose
      @cancel="close"
      :close-on-click-modal="false"
  >
    <div>
      <!--      {{ saved }}-->
      <!--      {{ defaultTimeBirthday }}-->
      <TopSearch :isRuleLock="isRuleLock" :adminShow="true" :isMarketing="true" :searchShow="true" :isTree="true"
                 @searchKey="getSearchKey" @changeDra="handleReset">
        <template #Birthday>
          <div style="display: flex;align-items: center" v-if="sessionStore.get('STEP_0_SELECT_TYPE')===1">
            <div class="label_marketing_birthday">{{
                $t('common.step.txt.select.1')
              }}:
            </div>
            <el-date-picker
                :disabled="true"
                size="small"
                v-model="defaultTimeBirthday"
                type="daterange"
                :start-placeholder="$t('sending.customer.search.startTime')"
                :end-placeholder="$t('sending.customer.search.endTime')"
                :default-time="defaultTimeBirthday"
                style="width: 200px;margin-left: 12px;"
            />
          </div>
        </template>
        <template #Marketing>
          <div style="display: flex;align-items: center">
            <div class="label_marketing">{{
                $t('common.edm.object')
              }}:
            </div>
            <div style="margin-left: 10px;">
              <el-checkbox :disabled="isRuleLock" v-model="allEmail"
                           :label="$t('common.edm.filter.1')" size="large"/>
              <el-checkbox :disabled="isRuleLock" v-model="companyEmail" :label="$t('common.edm.filter.2')"
                           size="large"/>
              <el-checkbox :disabled="isRuleLock" v-model="mainContactEmail" :label="$t('common.edm.filter.3')"
                           size="large"/>
              <el-checkbox :disabled="isRuleLock" v-model="commonContactEmail" :label="$t('common.edm.filter.4')"
                           size="large"/>
            </div>
          </div>
        </template>
      </TopSearch>
    </div>
    <template v-if="!isLoading">
      <div v-if="customerList.length!==0" style="margin-top: 15px">
        <div style="margin-top: 15px">
          <el-table
              v-loading="isLoading||isLoadingAll"
              :data="customerList"
              style="width: 100%;margin-top: 16px"
              lazy
              :height="'45vh'"
              id="addNewTable"
              ref="addNewTable"
              @select="handleSelectionChangeCustomerList"
              @select-all="handleClickSelectAll"
              @selection-change="handleSelectionChange"
              :header-cell-class-name="cellClass"
              :cell-style="rowClassName"
              :header-cell-style="headerClassName"
              :row-key="(row)=>row.id"
              @cell-mouse-leave="clearVisiblePopover"
          >
            <!--            :selectable="checkSelectable"-->
            <el-table-column type="selection" :reserve-selection="true" :selectable="checkSelectable" width="40"/>
            <el-table-column
                v-for="(item,index) in table_columns_public_list_group"
                :key="item.key"
                :label="item.key"
                :prop="item.value"
                label="Date"
                :width="handleClickSelectWidth(item)"
                :min-width="handleClickSelectMinWidth(item)"
            >
              <!--              :show-overflow-tooltip="item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
              <template #default="{ row, column, $index }">
                <template v-if="item.value === 'mangerVOList'">
                  <div class="hover" v-if="row.mangerVOList.length > 0">
                    <!-- 触发内容1 -->
                    <el-button link type="primary" :ref="ref => (refMap[row.customerCode] = ref)"
                               @mouseover.stop="handleRef(refMap[row.customerCode], row, 2)">
                      {{ row.mangerVOList.length }}
                    </el-button>
                  </div>
                  <template v-else>
                    <el-button link type="info">
                      {{ row.mangerVOList.length }}
                    </el-button>
                  </template>
                </template>
                <template v-else-if="item.value ==='zoneAddress'">
                  <div style="cursor: pointer;">
                    <!-- 触发内容1 -->
                    <el-image :ref="ref => (refMap[`${row.id}_list_img`] = ref)"
                              @mouseover.stop="handleRef(refMap[`${row.id}_list_img`], row, 3)"
                              v-if="row.zoneAddress"
                              :src="flag[row.zoneCode]"
                              style="width:26px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode"
                              lazy
                    />
                  </div>
                </template>
                <template v-else-if="item.value ==='lastTime'">
                  <div>{{ row.lastTime }}</div>
                </template>
                <template v-else-if="item.value === 'customerName'">
                  <div :ref="ref => (refMap[`${row.id}_tree_name`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_tree_name`], row, 5)"
                       v-if="getTextLength(row.customerName)>=sizeMaxNumber"
                       class="over_normal"
                       :key="row.customerName"
                  >
                    {{ row.customerName }}
                  </div>
                  <div v-else class="over_normal">
                    <div>{{ row.customerName }}</div>
                  </div>
                </template>
                <template v-else-if="item.value==='customerOrigin'">
                  <div :ref="ref => (refMap[`${row.id}_source`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_source`], row, 6)"
                       v-if="getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                       class="over_normal"
                       :key="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name">
                    <el-tag type="info"
                            v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{
                        getTextLength(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                            ? formatText(row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                            : row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name
                      }}
                    </el-tag>
                    <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                  <div v-else class="over_normal">
                    <el-tag type="info"
                            v-if="row?.mailCustomerOriginDetailVoList&&row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== '')[0]?.name }}
                    </el-tag>
                    <template v-else></template>
                    <template v-if="row?.mailCustomerOriginDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailCustomerOriginDetailVoList?.filter(it => it.name !== "").length - 1 }}
                    </template>
                  </div>
                </template>
                <template v-else-if="item.value==='customerIntention'">
                  <!--          {{ getTextLength(row?.mailLabelVoList.filter(item => item.type === 1)[0]?.name) }}-->
                  <div :ref="ref => (refMap[`${row.id}_product`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_product`], row, 9)"
                       v-if="getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !=='')[0]?.name) > sizeMaxNumber"
                       class="over_normal"
                       :key="row?.mailProductDetailVoList?.filter(it => it.name!=='')[0]?.name">
                    <el-tag type="info" v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length!==0">
                      {{
                        getTextLength(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name) > sizeMaxNumber
                            ? formatText(row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name, sizeMaxNumber, true)
                            : row?.mailProductDetailVoList?.filter(it => it.name !== '')[0]?.name
                      }}
                    </el-tag>
                    <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !=='').length>1">
                      +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                  <div v-else class="over_normal">
                    <el-tag type="info"
                            v-if="row?.mailProductDetailVoList&&row?.mailProductDetailVoList?.filter(it => it.name!=='').length!==0">
                      {{ row?.mailProductDetailVoList?.filter(it => it.name !== "")[0]?.name }}
                    </el-tag>
                    <template v-else></template>
                    <template v-if="row?.mailProductDetailVoList?.filter(it => it.name !== '').length>1">
                      +{{ row?.mailProductDetailVoList?.filter(it => it.name !== '').length - 1 }}
                    </template>
                  </div>
                </template>
                <template v-else-if="item.value === 'customerType'">
                  <div :ref="ref => (refMap[`${row.id}_customer_type`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_customer_type`], row, 4)"
                       v-if="getTextLength(row.customerType) > sizeMaxNumber"
                       :key="row.customerType"
                       class="over_normal">
                    {{
                      getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.customerType }}
                  </div>
                </template>
                <template v-else-if="item.value==='customerCode'">
                  <div :ref="ref => (refMap[`${row.id}_code`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_code`], row, 7)"
                       v-if="getTextLength(row.customerCode) > sizeMaxNumber+2"
                       class="over_normal"
                       :key="row.customerCode">
                    {{
                      getTextLength(row.customerCode) > sizeMaxNumber + 2 ? formatText(row.customerCode, sizeMaxNumber + 2) : row.customerCode
                    }}
                  </div>
                  <div v-else>
                    {{ row.customerCode }}
                  </div>
                </template>
                <template v-else-if="item.value==='email'">
                  <div :ref="ref => (refMap[`${row.id}_email`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_email`], row, 10)"
                       v-if="getTextLength(row.email) > sizeMaxNumber+2"
                       class="over_normal"
                       :key="row.email">
                    {{
                      getTextLength(row.email) > sizeMaxNumber + 2 ? formatText(row.email, sizeMaxNumber + 2) : row.email
                    }}
                  </div>
                  <div v-else>
                    {{ row.email }}
                  </div>
                </template>
                <template v-else-if="item.value==='contactName'">
                  <div :ref="ref => (refMap[`${row.id}_contactName`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_contactName`], row, 10)"
                       v-if="getTextLength(row.contactName) > sizeMaxNumber+2"
                       class="over_normal"
                       :key="row.contactName">
                    {{
                      getTextLength(row.contactName) > sizeMaxNumber + 2 ? formatText(row.contactName, sizeMaxNumber + 2) : row.contactName
                    }}
                  </div>
                  <div v-else>
                    {{ row.contactName ? row.contactName : "-" }}
                  </div>
                </template>
                <template v-else-if="item.value==='createName'">
                  <div :ref="ref => (refMap[`${row.id}_create_name`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_create_name`], row, 8)"
                       v-if="getTextLength(row.createName) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.createName">
                    {{
                      getTextLength(row.createName) > sizeMaxNumber ? formatText(row.createName, sizeMaxNumber) : row.createName
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.createName }}
                  </div>
                </template>
                <template v-else-if="item.value ==='lastTime'">
                  <div>{{ row.lastTime }}</div>
                </template>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
            </template>
          </el-table>
          <div class="pages">
            <Pagination v-model:modelValue="current"
                        v-model:pageSizeValue="size"
                        :total="totals"
                        v-if="totals"
                        ref="PageZQ"
                        :isShowLeft="false"
                        @change="handleCurrentChange"
                        @checkAllItemPage="checkAllItemPage"
                        @unCheckAllItemPage="unCheckAllItemPage"
                        @getSelect="getSelectValue"
                        :multipleSelection="multipleSelection"
            >
              <template #select>
                <div id="checkoutAll" ref="checkoutAll">
                  <el-checkbox
                      style="width: 40px !important;display: flex;justify-content: center;align-items: center;font-size: 13px !important;"
                      v-model="isSelectAll" size="large"
                      @change="selectAll"></el-checkbox>
                  <div style="font-size: 13px !important;">
                    {{
                      $t('common.computed.total', {
                        count: totals
                      })
                    }} |
                    {{
                      !isLoadingAll ? isSelectAll ? $t('tree.count.sum', {count: allCustomerList.length}) : $t('tree.count.sum', {
                        count: Array.from(
                            Object.values(selectedRows)
                                .filter(item => item.email && emailReg.test(item.email))
                                .reduce((map, current) => map.set(current.email, current), new Map())
                                .values()
                        ).length
                      }) : $t('tree.count.wating')
                    }}
                  </div>
                </div>
              </template>
            </Pagination>
          </div>
          <div class="rules">
            <el-checkbox v-model="isRuleLock" @change="handleClickChangeRule" :label="$t('common.rules.checkbox')"
                         size="large"/>
          </div>
        </div>
      </div>
      <div v-else class="display:flex;">
        <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
      </div>
    </template>
    <div style="height: 260px" v-if="isLoading" v-loading="isLoading"></div>
    <div class="settings">
      <ElButton size="small" @click="close">
        {{ $t('common.cancel') }}
      </ElButton>
      <ElButton size="small" type="primary" @click="addToEmails" :loading="isLoadingAll">
        {{ $t('common.confirm') }}
      </ElButton>
    </div>
    <el-popover
        v-model:visible="visiblePopover"
        :virtual-ref="tempRef"
        virtual-triggering
        trigger="hover"
        placement="right"
        effect="dark"
        :show-after="1200"
    >
      <template v-if="popoverType === 1">
        <div class="popover-content">
          <div
              v-for="(item, index) in activeItemElpopover.maiContactVOList"
              :key="index"
          >
            {{ item.contactName }}
          </div>
        </div>
      </template>

      <template v-else-if="popoverType === 2">
        <div class="popover-content">
          <div
              v-for="(item, index) in activeItemElpopover.mangerVOList"
              :key="index"
          >
            {{ item.managerName }}
          </div>
        </div>
      </template>

      <template v-else-if="popoverType === 3">
        <div class="popover-content">
          {{ activeItemElpopover.zoneAddress }}
        </div>
      </template>

      <template v-else-if="popoverType === 4">
        <div class="popover-content">
          {{ activeItemElpopover.customerType }}
        </div>
      </template>

      <template v-else-if="popoverType === 5">
        <div class="popover-content">
          {{ activeItemElpopover.customerName }}
        </div>
      </template>

      <template v-else-if="popoverType === 6">
        <div class="popover-content">
          {{ activeItemElpopover?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '')[0].name }}
        </div>
      </template>

      <template v-else-if="popoverType === 7">
        <div class="popover-content">
          {{ activeItemElpopover.customerCode }}
        </div>
      </template>

      <template v-else-if="popoverType === 8">
        <div class="popover-content">
          {{ activeItemElpopover.createName }}
        </div>
      </template>

      <template v-else-if="popoverType === 9">
        <div class="popover-content">
          {{ activeItemElpopover?.mailProductDetailVoList?.filter(it => it.type === 2)[0].name }}
        </div>
      </template>
      <template v-else-if="popoverType===10">
        <div class="popover-content">
          {{ activeItemElpopover?.email }}
        </div>
      </template>
    </el-popover>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElTable,} from "element-plus";
import {ref, defineProps, watch, defineEmits, computed, onMounted, nextTick, onBeforeUnmount} from 'vue'
import {useStore} from "vuex";
import {getGroupMassCustomerList, getMailCustomerList, getMassCustomerList} from "@/api/customer";
import TopSearch from "@/views/Customer/TopComponents/TopSearch.vue";
import {emailReg, emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import {table_columns_public_list, table_columns_public_list_group} from "@/views/Customer/map";
import {flexWidth} from "@/utils/tableWidth";
import flag from "@/assets/flag";
import {replaceMailMassEmailVOListWithChildren} from "@/utils/filters";
import {debouncePlus, isEmpty, throttle} from "@/utils/mylodash";
import {formatText, getTextLength, getTextWidth} from "@/utils/util";
import Pagination from "@/components/Pagination/index.vue";
import {i18n} from "@/lang"
import OverflowTooltip from "@/components/OverflowTooltip/index.vue";
import dayjs, {Dayjs} from "dayjs";
import {useRoute} from "vue-router";
import {UserTable} from "@/views/Marketing/db_user";
import {CustomerTable} from "@/views/Marketing/db_customer";
import sessionStore from "@/utils/sessionStore";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const teamName = ref("")
const loading = ref(false);
const route = useRoute()


const current = ref(1);
const size = ref(20)
const totals = ref(0)

const addNewTable = ref(null)
const allCustomerList = ref([])
// const baseAllCustomerList = ref([])
const isSelectAll = ref(false)
const baseCustomerList = ref([])

// 假设 Storage.get 是同步的
const raw = sessionStore.get('STEP_1_RULE') || {}
// 不需要把 saved 设成空的 ref 再去读
// 邮箱筛选
const saved = ref(raw)
const allEmail = ref(saved.value.allEmail || false)
const companyEmail = ref(saved.value.companyEmail || false)
const mainContactEmail = ref(saved.value.mainContactEmail || false)
const commonContactEmail = ref(saved.value.commonContactEmail || false)
// 规则锁定
const isRuleLock = ref(saved.value.isRuleLock || false)

// 生日营销
const isShowB = computed(() => sessionStore.get("STEP_0_SELECT_TYPE") === 1)

const today = new Date()

const defaultTimeBirthday = ref([
  dayjs().add(1, 'day').toDate(),     // 明天
  dayjs().endOf('year').toDate()      // 当年年末
])

// 两个标志位：由全选发起的更新 / 由子项发起的更新
let updatingFromAll = false
let updatingFromChild = false

const handleClickChangeRule = async () => {
  await sessionStore.set("STEP_1_RULE", {
    ...searchValue.value,
    isRuleLock: isRuleLock.value,
    allEmail: allEmail.value,
    companyEmail: companyEmail.value,
    mainContactEmail: mainContactEmail.value,
    commonContactEmail: commonContactEmail.value,
  })
}

// 监听 allEmail（全选触发时设置子项）
watch(allEmail, (val) => {
  // 如果这次变化是子项的副作用，就跳过
  if (updatingFromChild) return

  updatingFromAll = true
  companyEmail.value = val
  mainContactEmail.value = val
  commonContactEmail.value = val

  // 异步清除标志，防止和后续同步 watch 冲突
  requestAnimationFrame(() => {
    updatingFromAll = false
  })
})

// 监听后三个（手动操作子项时更新 allEmail）
watch([companyEmail, mainContactEmail, commonContactEmail], ([a, b, c]) => {
  // 如果是全选正在批量设置子项，则不用再次去设置 allEmail
  if (updatingFromAll) return

  updatingFromChild = true
  allEmail.value = a && b && c

  // 异步清除标志
  requestAnimationFrame(() => {
    updatingFromChild = false
  })
})


// 页面 进行翻页
const handleCurrentChange = async (val) => {
  const {pageNo, pageSize} = val
  current.value = pageNo
  size.value = pageSize
  // allCustomerList.value = computedTargetArray.value.endArray
  // console.log(computedTargetArray.value.endArray, 'computedTargetArray.value.endArray')
  //  重新获取数据
  await getCustomerList()
  // console.log(isSelectAll.value, JSON.parse(isCounterElection.value), 'flag')
  // 全选
  if (isSelectAll.value) {
    await selectAll()
  }
  // 反选
  if (JSON.parse(isCounterElection.value)) {
    counterElection()
  }
}


const counterElection = () => {
  console.log('反选')
  if (isSelectAll.value) {
    //   取消全部勾选
    isSelectAll.value = false
    customerList.value.forEach((item) => {
      addNewTable?.value.toggleRowSelection(item, isSelectAll.value)
    })
  } else {
    //   针对所有的数据进行反选
    // 反选这里有问题 ==== 全部数据 无法实现
    const selectedIds = new Set(Object.values(selectedRows.value).map(row => row.id));
    customerList.value.forEach(item => {
      if (selectedIds.has(item.id)) {
        addNewTable?.value.toggleRowSelection(item); // 如果已经选中则取消选中
      } else {
        addNewTable?.value.toggleRowSelection(item); // 如果没有选中则选中
      }
    });
  }
}


// 是否可以进行勾选
const checkSelectable = (row, index) => {
  // if (route.query.massOrigin * 1 === 1) {
  //   return !isSelectAll.value;
  // } else {
  //   if (row.isCheck === 1) return true   // 可勾选
  //   if (row.isCheck === 0) return false  // 禁用复选框
  //   console.log(row, 'row')
  //   return null                          // 等价于 true，依然可勾选
  // }

  return !isSelectAll.value
}

const targetEmailList = ref([])
const selectedRows = computed(() => store.state.customer.selectedRows)
const globalSelectedRows = computed(() => store.state.customer.globalSelectedRows)

// select 选择每一行
const handleSelectionChangeCustomerList = async (val) => {
  console.log(val, '当前页勾选的值');
  // isSelectAll.value = false
  // 选择 底部选择 取消 全部勾选
  await nextTick(async () => {
    // 获取当前页的页码，假设分页数据存储在 store 中
    const currentPage = current.value;

    // 获取全局勾选记录
    const globalSelectedRows = store.state.customer.globalSelectedRows || {};

    // 更新当前页的勾选数据到全局记录
    globalSelectedRows[currentPage] = val;

    // 提交更新全局勾选记录到 store
    await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

    // 合并所有页的勾选数据
    const allSelectedRows = Object.values(globalSelectedRows).flat();

    // 更新 `selectedRows` 和 `targetEmailList`
    await store.commit("customer/setSelectedRows", allSelectedRows);
    targetEmailList.value = allSelectedRows;
    console.log(targetEmailList.value, allSelectedRows, 'targetEmailList');
  })
}
// 一页中的勾选全部
const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值');
  // 获取当前页的页码，假设分页数据存储在 store 中
  const currentPage = current.value;

  // 获取全局勾选记录
  const globalSelectedRows = store.state.customer.globalSelectedRows || {};

  // 更新当前页的勾选数据到全局记录
  globalSelectedRows[currentPage] = val;

  // 提交更新全局勾选记录到 store
  await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

  // 合并所有页的勾选数据
  const allSelectedRows = Object.values(globalSelectedRows).flat();

  // 更新 `selectedRows` 和 `targetEmailList`
  await store.commit("customer/setSelectedRows", allSelectedRows);
  targetEmailList.value = allSelectedRows;
  console.log(targetEmailList.value, 'targetEmailList');
}

// 勾选 选择全部
const selectAll = async () => {
  await getCustomerAllList()
  console.log(selectedRows.value, 'selectedRows', globalSelectedRows.value)
  customerList.value.forEach((item) => {
    addNewTable?.value.toggleRowSelection(item, isSelectAll.value)
  })
}

function isEmptyObject(obj) {
  return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
}

//
const computedTargetArray = computed(() => {
  const historyArray = Object.values(globalSelectedRows.value).flat();
  const selectRowArray = selectedRows.value;
  console.log(selectRowArray.value, selectedRows.value, 'selectRowArray')
  let merged = []
  if (!isEmptyObject(selectRowArray)) {
    merged = [...new Set([...historyArray, ...selectRowArray])]
  } else {
    merged = [...new Set([...historyArray])]
  }
  const uniqueArray = merged.reduce((acc, current) => {
    // 检查当前元素的 id 是否已经在 accumulator 中
    if (!acc.some(item => item.id === current.id)) {
      acc.push(current);
    }
    return acc;
  }, []);

  // 取差集 计算 单页 未选中的项
  const difference = customerList.value.filter(item2 =>
      !uniqueArray.some(item1 => item1.id === item2.id)
  );
  // 与总数据 做差集；计算出剩余的项
  const endArray = allCustomerList.value.filter(item1 =>
      !difference.some(item2 => item2.id === item1.id)
  );

  console.log(uniqueArray, 'uniqueArray', endArray, difference, allCustomerList.value)
  // 数据总条数
  const total = isSelectAll.value ? totals.value : endArray.length;
  let emailTotal = isSelectAll.value ? allTargetEmailList.value : endArray;
  if (isSelectAll.value) {
    console.log(allTargetEmailList.value.length, '=====')
    emailTotal = allTargetEmailList.value
  }
  // console.log({total, emailTotal, endArray, difference}, '{total, emailTotal, endArray, difference}')
  return ({total, emailTotal, endArray, difference})
})

const isCounterElection = computed(() => store.state.customer.isCounterElection);
const query = ref('')

const {value, isChecked} = defineProps({
  value: {type: Boolean, default: false},
  isChecked: {type: Array, default: []}
})

watch(() => value, (val) => {
  isShow.value = val;
  localStorage.removeItem("selectedRows")
  localStorage.removeItem("globalSelectedRows")
}, {immediate: true})


const customerList = ref([])
const teamId = computed(() => store.state.email.teamID);
const isLoading = ref(false);
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const userInfo = computed(() => store.state.user.userInfo)
// 搜索
const searchValue = ref({});
const empty = ref(i18n.global.t('select.empty'))
const getSearchKey = async (value) => {
  isSelectAll.value = false
  const newObj = JSON.parse(JSON.stringify(value));
  if (newObj.customerOrigin === empty.value) {
    newObj.customerOrigin = ''
  }
  if (newObj.product === empty.value) {
    newObj.product = ''
  }
  if (newObj.customerTypeId === empty.value) {
    newObj.customerTypeId = ''
  }
  searchValue.value = newObj;
  if (searchValue.value.managerId === "all") {
    searchValue.value.managerId = ""
  }
  await sessionStore.set("STEP_1_RULE", searchValue.value)
  console.log(searchValue.value, 'searchValue.value')
  current.value = 1;
  // 列表数据
  await getCustomerList();
};


// 获取所有的客户以及客户的邮箱地址
const getCustomerList = async () => {
  isLoading.value = true;

  // getGroupMassCustomerList
  const massOriginTarget = route.query.massOrigin * 1
  const payload = {
    ...searchValue.value,
    commonContactEmail: commonContactEmail.value,
    companyEmail: companyEmail.value,
    mainContactEmail: mainContactEmail.value,
    allEmail: allEmail.value,
    teamId: teamId.value,
    pageSize: size.value,
    pageNo: current.value,
    isSelectAll: 1,
    type: 1,
    massOrigin: massOriginTarget,
  }
  if (massOriginTarget === 3) {
    // 跟进
    const list = await CustomerTable.getAll()
    payload.customerIdList = list.map(_ => _.customerId)
  }
  if (route.query.taskId) {
    payload.massTaskId = route.query.taskId;
  }
  // 只有编辑的时候可以选择所有的客户
  if (massOriginTarget === 2 && route.query.taskId) {
    payload.massOrigin = 1;
  }
  await getGroupMassCustomerList(payload).then((res) => {
    customerList.value = res.result?.records ?? []
    baseCustomerList.value = res.result?.records ?? [];
    current.value = res.result?.current;
    totals.value = res.result?.total
    isLoading.value = false;
  }).catch((e) => {
    console.log(e)
    isLoading.value = false;
  }).finally(async () => {
    isLoading.value = false;
    //   选择
    // if (route.query.massOrigin * 1 === 2) {
    //   await nextTick()
    //   customerList.value.forEach(row => {
    //     if (row.isCheck === 1) {
    //       addNewTable.value.toggleRowSelection(row, true)
    //     } else {
    //       addNewTable.value.toggleRowSelection(row, false)
    //     }
    //   })
    // } else if (route.query.massOrigin * 1 === 1) {
    //   await nextTick()
    //   // 获取缓存中的数据
    //   const getUserList = await UserTable.getAll()
    //   const targetIdList = getUserList.filter(_ => _.id && _.email).map(item => item.id)
    //   console.log(getUserList, targetIdList, 'getUserList')
    //   customerList.value.forEach(row => {
    //     if (targetIdList.includes(row.id)) {
    //       addNewTable.value.toggleRowSelection(row, true)
    //     } else {
    //       addNewTable.value.toggleRowSelection(row, false)
    //     }
    //   })
    // } else if (route.query.massOrigin * 1 === 3) {
    //   await nextTick()
    //   const getUserListId = await sessionStore.get('STEP_FOLLOW_CUSTOMER')
    //   customerList.value.forEach(row => {
    //     if (getUserListId.includes(row.id)) {
    //       addNewTable.value.toggleRowSelection(row, true)
    //     } else {
    //       addNewTable.value.toggleRowSelection(row, false)
    //     }
    //   })
    //   targetEmailList.value = customerList.value;
    // } else if (route.query.massOrigin * 1 === 4) {
    //   await nextTick()
    //   if (route.query.step * 1 === 1) {
    //     let resList = await sessionStore.get("STEP_TASK_TARGET_EMAIL")
    //     const emailListData = resList.map(item => item.toEmail)
    //     customerList.value.forEach(row => {
    //       if (emailListData.includes(row.email)) {
    //         addNewTable.value.toggleRowSelection(row, true)
    //       } else {
    //         addNewTable.value.toggleRowSelection(row, false)
    //       }
    //     })
    //   } else if (route.query.step * 1 === 0) {
    //     customerList.value.forEach(row => {
    //       if (row.isCheck === 1) {
    //         addNewTable.value.toggleRowSelection(row, true)
    //       } else {
    //         addNewTable.value.toggleRowSelection(row, false)
    //       }
    //     })
    //   }
    // }
  });
};


const cellClass = (row) => {
  if (row.columnIndex === 0) {
    return isSelectAll.value ? "disabledCheck" : "abledCheck"
  }
}

// 获取全部的客户 -这里没有分页
const getCustomerAllList = async () => {
  if (searchValue.value.managerId === "all") {
    searchValue.value.managerId = ""
  }
  isLoadingAll.value = true
  const massOriginTarget = route.query.massOrigin * 1
  const payload = {
    ...searchValue.value,
    teamId: teamId.value,
    isSelectAll: 0,
    massOrigin: massOriginTarget,
  }
  if (massOriginTarget === 3) {
    //   跟进
    const list = await CustomerTable.getAll()
    payload.customerIdList = list.map(_ => _.customerId)
  }
  await getMassCustomerList(payload).then((res) => {
    // baseAllCustomerList.value = res.result.records;
    allCustomerList.value = res.result
    isLoadingAll.value = false
  });
}

const allTargetEmailList = computed(() => allCustomerList.value.filter(item => item.email && emailReg.test(item.email))) // 确保 email 存在


//收集邮箱并添加
const isLoadingAll = ref(false)
const addToEmails = async () => {
  console.log(computedTargetArray.value.emailTotal, targetEmailList.value, 'computedTargetArray.value.emailTotal')
  if (isSelectAll.value) {
    // type 1 客户群发
    // 全部勾选
    await emit('addToEmail', computedTargetArray.value.emailTotal.map(item => ({
      email: item.email,
      customerCode: item.customerCode,
      customerId: item.customerId,
      customerName: item.customerName || "",
      zoneCode: item.zoneCode,
      zoneAddress: item.zoneAddress,
      contactName: item.contactName || "",
      type: 1
    })))
  } else {
    // type 1 客户群发
    await emit('addToEmail', targetEmailList.value.map(item => ({...item, type: 1})))
  }
  await handleClickChangeRule()
  await store.commit("customer/setGlobalSelectedRows", {});
  store.commit("customer/setSelectedRows", []);
  await close()
}

// 全部勾选 监听
watch(() => isSelectAll.value, async (newValue) => {
  if (!newValue) {
    targetEmailList.value = [];
    await store.commit("customer/setSelectedRows", []);
    await store.commit("customer/setGlobalSelectedRows", {});
  }
})

const close = async () => {
  await store.commit("customer/setGlobalSelectedRows", {});
  store.commit("customer/setSelectedRows", []);
  emit("close");
}

onMounted(async () => {
  await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 6 || columnIndex === 7) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 6 || columnIndex === 7) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

// 记录历史记录
const resetSelection = async () => {
  await nextTick(() => {
    if (addNewTable?.value) {
      customerList.value.forEach((item) => {
        const isSelected = Object.values(selectedRows.value).some((selected) => selected.id === item.id);
        addNewTable?.value.toggleRowSelection(item, isSelected);
      })
    }
  })
}

// 当前页数据发生变化
watch(() => customerList.value, (newValue) => {
  if (newValue) {
    console.log('newValue')
    resetSelection()
  }
}, {immediate: true})


// shift 选择
let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};

const multipleSelection = computed(() => store.state.customer.multipleSelection)
const handleSelectionChange = async (val) => {
  // console.log("val-----------------------", val)
  //判断是否按住shirt键盘
  // console.log(isShiftPressed.value);
  endIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
  const startIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
  console.log(endIndex, startIndex);
  if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
    const start = startIndex < endIndex ? startIndex : endIndex;
    const end = endIndex < startIndex ? startIndex : endIndex;
    // console.log(start, end, '===============');
    for (let i = start; i <= end; i++) {
      const row = customerList.value[i];
      if (start === i || i === end) {
        continue;
      }
      console.log(row, '更新');
      if (row) {
        addNewTable.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
      }
    }
    // nextTick(async () => {
    //   const currentPage = current.value;
    //   const globalSelectedRows = store.state.customer.globalSelectedRows || {};
    //   globalSelectedRows[currentPage] = treeTable.value.getSelectionRows();
    //   await store.commit("customer/setGlobalSelectedRows", globalSelectedRows)
    //   console.log(treeTable.value.getSelectionRows(), '当前选中行');
    // });
    nextTick(async () => {
      await store.commit("customer/setMultipleSelection", addNewTable.value.getSelectionRows())
    });
    // Shift 键被按下，进行批量选中处理
    // const firstRow = val[0];
    // const lastRow = val[val.length - 1];
    // const firstIndex = tableData.value.findIndex(item => item.id === firstRow.id);
    // const lastIndex = tableData.value.findIndex(item => item.id === lastRow.id);


    // if (firstIndex !== -1 && lastIndex !== -1) {
    //   const start = Math.min(firstIndex, lastIndex);
    //   const end = Math.max(firstIndex, lastIndex);
    //   console.log("start", start)
    //   console.log("end:", end)
    //   for (let i = start; i <= end; i++) {
    //     const row = tableData.value[i];
    //     if (row) { // 检查行是否存在，以防索引超出范围
    //       tableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
    //     }
    //   }
    //   for (let i = 0; i < 40; i++) {
    //     if (start <= i && i <= end) {
    //       continue
    //     }
    //     const row = tableData.value[i];
    //     if (row) { // 检查行是否存在，以防索引超出范围
    //       tableRef.value.toggleRowSelection(row, false); // 调用表格组件的方法来更新选中状态
    //     }
    //   }
    //   //批量勾选
    //   multipleSelection.value = tableData.value.slice(start, end + 1).map(row => ({...row}));
    // }
    // console.log("multipleSelection.value-------------", multipleSelection.value)
  } else {
    //走正常逻辑
    // const currentPage = current.value;
    // const globalSelectedRows = store.state.customer.globalSelectedRows || {};
    // globalSelectedRows[currentPage] = val
    await store.commit("customer/setMultipleSelection", val)
  }
}


// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}

const checkAllItemPage = () => {
  addNewTable.value.clearSelection()
  isSelectAll.value = true
}
const unCheckAllItemPage = () => {
  addNewTable.value.clearSelection()
  isSelectAll.value = false
}

const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  await nextTick(() => {
    customerList.value.forEach((item) => {
      addNewTable?.value.toggleRowSelection(item, isSelectAll.value)
    })
  })
}


const lang = computed(() => store.state.system.langLocal)
// 设置 临界值 width
const middleValueWidth = ref(160)
// 字数大致限制
const sizeMaxNumber = ref(13)
const handleClickSelectWidth = (item) => {
  if (item.value === "customerCode") {
    return flexWidth('customerCode', customerList.value, i18n.global.t('common_customer_number')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerCode', customerList.value, i18n.global.t('common_customer_number')) + 20
  } else if (item.value === "customerType") {
    return flexWidth('customerType', customerList.value, i18n.global.t('common_customer_type')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerType', customerList.value, i18n.global.t('common_customer_type')) + 20
  } else if (item.value === 'customerIntention') {
    return flexWidth('customerIntention', customerList.value, i18n.global.t('common.interest.product')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerIntention', customerList.value, i18n.global.t('common.interest.product')) + 30
  } else if (item.value === 'customerOrigin') {
    return flexWidth('customerOrigin', customerList.value, i18n.global.t('common.customer.source')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerOrigin', customerList.value, i18n.global.t('common.customer.source')) + 30
  } else if (item.value === 'createName') {
    return flexWidth('createName', customerList.value, i18n.global.t('common.byinput')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('createName', customerList.value, i18n.global.t('common.byinput')) + 20
  } else if (item.value === 'customerLevel') {
    return lang.value !== 'zh-CN' ? 140 : 80;
  } else if (item.value === 'maiContactVOList' || item.value === 'zoneAddress' || item.value === 'auditName' || item.value === 'userName' || item.value === 'mangerVOList') {
    return 80;
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'setting' || item.value === 'auditStatus') {
    return 120;
  } else {
    return "auto"
  }
}

const handleClickSelectMinWidth = (item) => {
  if (item.value === "customerLevel") {
    return 140;
  } else if (item.value === 'createName') {
    return 200;
  } else {
    return "auto";
  }
}

const handleReset = () => {
  allEmail.value = false;
  companyEmail.value = false;
  mainContactEmail.value = false;
  commonContactEmail.value = false;
}
</script>
<style scoped lang="less">
.pages {
  height: 40px;
}

.tables {
  margin-top: 10px !important;
}

//设置每个按钮
:deep(.el-pager li) {
  border-radius: 4px !important;
  margin-right: 4px !important;
  border: 1px solid #d9d9d9 !important;
  transition: all 0.3s ease-in-out !important;
}

//设置最左边的按钮
:deep(.btn-prev) {
  border-radius: 4px;
  margin-right: 4px;
  font-size: 20px;
  border: 1px solid #d9d9d9;
  transition: all 0.3s ease-in-out;
}

//设置最右边的按钮
:deep(.btn-next) {
  border-radius: 4px;
  margin-left: 4px;
  border: 1px solid #d9d9d9;
  transition: all 0.3s ease-in-out;
}

//设置选中的按钮的样式
:deep(.el-pager li.is-active) {
  border-radius: 4px !important;
  background-color: white !important;
  color: #1890ff !important;
  border: 1px solid #1890ff !important;
  transition: all 0.3s ease-in-out !important;
}

//设置整个分页器的位置
:deep(.el-pagination) {
  float: right;
}

:deep(.number) {
  margin: 0px 4px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  transition: all 0.3s ease-in-out;
}

:deep(.el-pagination.is-background .btn-next) {
  background-color: white !important;
}

:deep(.el-pagination.is-background .el-pager li) {
  background-color: white !important;
}

:deep(.el-pagination.is-background .btn-prev) {
  background-color: white !important;
}


.fx-j-c {
  display: flex;
  justify-content: center;
}

.settings {
  //margin-top: 20px;
  padding-top: 0px !important;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: 10px;
}

:deep(.el-checkbox__inner::after) {
  top: 1px !important;
  left: 5px !important;
}

#checkoutAll {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

:deep(.disabledCheck .el-checkbox__input) {
  display: none !important;
  padding: 0px !important;
}

:deep(.abledCheck .el-checkbox__input) {
  display: block !important;
  padding: 0px !important;
}

:deep(.disabledCheck) {
  padding: 0px !important;
}

:deep(.abledCheck) {
  padding: 0px !important;
}

:deep(.el-tooltip>div) {
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

:deep(.el-table__header) {
  width: 100% !important;
}

:deep(.el-table__body) {
  width: 100% !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-table [class*=el-table__row--level] .el-table__expand-icon) {
  float: left !important;
  padding-top: 5px !important;
}

:deep(.el-dialog__footer) {
  padding-top: 0px !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

:deep(.el-dialog__header) {
  display: flex !important;
}

:deep(.el-checkbox__label) {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: normal !important;
}

.label_marketing {
  color: rgba(0, 0, 0, 0.85) !important;
  font-size: 13px !important;
  //margin-left: -65px !important;
  width: 86px;

  :deep(.el-checkbox) {
    margin-right: 34px !important;
  }
}

.rules {
  width: 100%;
  display: flex;
  align-items: center;
  margin-left: 13px !important;

  :deep(.el-checkbox__label) {
    font-size: 13px !important;
    color: #D93737 !important;
    font-weight: normal !important;
  }
}

.label_marketing_birthday {
  color: rgba(0, 0, 0, 0.85) !important;
  font-size: 13px !important;
  width: 56px;
}
</style>
